import { createStore } from "vuex";
import { states } from "./states";
import { mutations } from "./mutations";
import { StateOption } from "../types/state_option";
import { actions } from "./actions";

//#region Vuex Store Creation

export const store = createStore<StateOption>({
    state: states,
    mutations: mutations,
    actions: actions
});

//#endregion
